var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationScanQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 398.904,
    height: 400,
    viewBox: "0 0 398.904 800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-642 -139.966)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(642 139.966)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.268,269.3h-4.4V148.885a69.692,69.692,0,0,0-69.692-69.692H336.058a69.693,69.693,0,0,0-69.693,69.692V809.5a69.693,69.693,0,0,0,69.692,69.692H591.178A69.693,69.693,0,0,0,660.87,809.5V355.018h4.4Z",
    transform: "translate(-266.365 -79.193)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.254,95.686h-33.3a24.727,24.727,0,0,1-22.894,34.067H389.9A24.727,24.727,0,0,1,367,95.686H335.9a52.045,52.045,0,0,0-52.045,52.045V807.383A52.045,52.045,0,0,0,335.9,859.428H592.244a52.045,52.045,0,0,0,52.045-52.045V147.733a52.045,52.045,0,0,0-52.036-52.045Z",
    transform: "translate(-264.621 -77.553)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(712.884 410.628)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 257,
    rx: 6,
    transform: "translate(-0.162 0.338)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    rx: 6,
    transform: "translate(10.838 11.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.509,3.673A1.838,1.838,0,0,0,3.673,5.509V27.544A1.838,1.838,0,0,0,5.509,29.38H27.544a1.838,1.838,0,0,0,1.836-1.836V5.509a1.838,1.838,0,0,0-1.836-1.836H5.509M5.509,0H27.544a5.509,5.509,0,0,1,5.509,5.509V27.544a5.509,5.509,0,0,1-5.509,5.509H5.509A5.509,5.509,0,0,1,0,27.544V5.509A5.509,5.509,0,0,1,5.509,0Z",
    transform: "translate(10.874 10.889)",
    fill: "#A47CEA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    rx: 4,
    transform: "translate(17.838 18.338)",
    fill: "#A47CEA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(212.838 11.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.509,3.673A1.838,1.838,0,0,0,3.673,5.509V27.544A1.838,1.838,0,0,0,5.509,29.38H27.544a1.838,1.838,0,0,0,1.836-1.836V5.509a1.838,1.838,0,0,0-1.836-1.836H5.509M5.509,0H27.544a5.509,5.509,0,0,1,5.509,5.509V27.544a5.509,5.509,0,0,1-5.509,5.509H5.509A5.509,5.509,0,0,1,0,27.544V5.509A5.509,5.509,0,0,1,5.509,0Z",
    transform: "translate(212.864 10.889)",
    fill: "#A47CEA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    rx: 4,
    transform: "translate(220.838 18.338)",
    fill: "#A47CEA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 34,
    rx: 6,
    transform: "translate(10.838 212.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.509,3.673A1.838,1.838,0,0,0,3.673,5.509V27.544A1.838,1.838,0,0,0,5.509,29.38H27.544a1.838,1.838,0,0,0,1.836-1.836V5.509a1.838,1.838,0,0,0-1.836-1.836H5.509M5.509,0H27.544a5.509,5.509,0,0,1,5.509,5.509V27.544a5.509,5.509,0,0,1-5.509,5.509H5.509A5.509,5.509,0,0,1,0,27.544V5.509A5.509,5.509,0,0,1,5.509,0Z",
    transform: "translate(10.874 212.878)",
    fill: "#A47CEA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 4,
    transform: "translate(17.838 220.338)",
    fill: "#A47CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.665,255.771v-3.926H94.813v-15.7h7.852V212.588h7.852v-7.852h-15.7v-7.852H63.407v-7.852h7.852v-7.852h-15.7v15.7H47.7v-7.852H32v-7.852H47.7v-15.7H39.852v7.852H32v-15.7H47.7v7.852h7.852v7.852h7.852v-7.852h7.852v7.852h15.7v-7.852H79.11v-7.852H55.555v-7.852H79.11v-7.852H55.555v-7.852H47.7v7.852H32V118.368h7.852v7.852h47.11v-7.852H79.11v-7.852h-15.7v7.852H55.555v-7.852h-15.7v-15.7h15.7v15.7h7.852v-7.852h15.7V94.813h7.852v7.852H79.11v7.852h7.852v7.852h7.852v-15.7h7.852V94.813H94.813V71.258h15.7V79.11h7.852v7.852h-7.852v7.852h7.852v47.11h-15.7v-7.852H94.813v7.852H86.961v7.852H79.11v7.852h7.852v7.852h7.852v7.852h15.7v-7.852h-7.852v-7.852H94.813v-7.852h15.7v15.7h7.852v-15.7h7.852v15.7h7.852V141.923h7.852v-7.852h7.852v7.852h-7.852v7.852h7.852v7.852h23.555v-7.852h-7.852v-7.852h-7.852v-15.7h-7.852v-7.852h7.852v-7.852h7.852v-7.852h-7.852V94.813h-7.852v15.7h-7.852v-7.852h-7.852v7.852H126.22v-7.852h7.852V94.813H126.22V71.258h-7.852V63.407h7.852v7.852h7.852V39.852h7.852v15.7h15.7V47.7h-7.852V32h15.7v7.852h-7.852V47.7h15.7V39.852h7.852V47.7h-7.852v15.7h7.852V86.961h7.852V79.11h7.852v39.258h15.7v-7.852h-7.852v-15.7h15.7v23.555h15.7v-7.852h-7.852v-15.7h7.852v15.7h7.852v-7.852h15.7v15.7h-7.852v-7.852h-7.852v7.852h-7.852v23.555h7.852v7.852h-7.852v7.852h-15.7v7.852h-7.852v7.852h-15.7v-7.852h-7.852v-7.852h-7.852v15.7h7.852v7.852h23.555v7.852h15.7v-7.852h-7.852v-7.852h7.852v-7.852h7.852v7.852h7.852v7.852h7.852v-15.7h-7.852v-7.852h15.7v23.555h-7.852v15.7H259.7v15.7h-7.852v23.555H259.7v7.852H236.142v15.7H212.588v-7.852h15.7v-7.852h-15.7v-15.7h-7.852v15.7h-7.852v7.852h7.852V259.7h-15.7V236.142h-7.852v15.7h-7.852v-7.852h-7.852V212.588h7.852v23.555h7.852V212.588h7.852v-15.7h-7.852v-7.852h-7.852v-7.852h7.852v-7.852h-7.852v-7.852h-7.852v31.407h7.852v7.852h-15.7v15.7h-7.852v15.7h7.852v7.852h-7.852v7.852h15.7V259.7h-15.7v-7.852h-7.852v-7.852h-7.852v15.7H102.665v-3.926Zm23.555-11.777v-7.852h7.852V212.588h-15.7v7.852h7.852v7.852h-15.7v7.852h-7.852v7.852h7.852v7.852h15.7v-7.852Zm109.923-7.852v-7.852h7.852v-15.7h7.852v-7.852h-7.852V181.181h-7.852v23.555h7.852v7.852h-7.852v7.852h-7.852v23.555h7.852v-7.852Zm-39.258-3.926v-3.926h-7.852v7.852h7.852v-3.926Zm-47.11-15.7v-3.926h-7.852v7.852h7.852v-3.926Zm70.665-7.852V196.884H196.884v23.555h23.555V208.662Zm-28.636,0,3.712-12.871,27-1.2-.9,26.718h-26.1Zm-49.88-7.852v-3.926h15.7v-7.852h-15.7v-7.852h-7.852v7.852h7.852v7.852h-15.7v-7.852h-7.852v7.852h-7.852v-7.852h-7.852v-7.852H94.813v-7.852H86.961v7.852H79.11v7.852h7.852v-7.852h7.852v7.852h7.852v7.852h7.852v7.852h31.407V200.81Zm-23.555-23.555v-3.926h-7.852v7.852h7.852v-3.926Zm39.258-3.926v-7.852h-15.7v7.852h7.852v7.852h7.852v-7.852Zm47.11-11.777v-3.926h-7.852v7.852h7.852v-3.926Zm15.7-7.852v-3.926h7.852V126.22h-7.852v7.852h-7.852v7.852h-7.852v-7.852h-15.7V126.22h-7.852v-7.852h7.852V94.813h-7.852V86.961h-7.852V79.11h-7.852v7.852h-7.852V63.407h7.852v7.852h7.852V63.407h-7.852V55.555h-7.852v7.852h-7.852V86.961h7.852v7.852h7.852V86.961h7.852v23.555h-7.852v7.852h-7.852v7.852h7.852v15.7h7.852v-7.852h15.7v7.852h7.852v7.852h15.7v7.852h7.852V153.7Zm-7.852-7.852v-3.926h7.852v7.852h-7.852v-3.926ZM86.961,138l7.852-3.926V126.22H86.961v7.852H79.11v7.852h7.852V138Zm23.555-15.7v-3.926h-7.852v7.852h7.852Zm0-39.258V79.11h-7.852v7.852h7.852V83.036Zm31.407-3.926V71.258h-7.852v15.7h7.852V79.11Zm39.258-39.258Zm70.665,215.92v-3.926H259.7V259.7h-7.852v-3.926Zm0-113.849v-7.852h-7.852V126.22h7.852v7.852H259.7v15.7h-7.852v-7.852ZM86.961,86.961Zm7.852-27.481V55.555h7.852v7.852H94.813V59.481Zm15.7-7.852V47.7h-7.852V32h7.852v7.852h7.852V32h7.852v7.852h-7.852v15.7h-7.852V51.629Z",
    transform: "translate(-18.372 -13.766)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H360.777V88.931a58.614,58.614,0,0,1-58.614,58.614H58.614A58.614,58.614,0,0,1,0,88.931Z",
    transform: "translate(661.201 779.698)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(681.722 378.966)",
    fill: "none",
    stroke: "#090814",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 321,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 315,
    height: 316,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 257,
    transform: "translate(992.722 415.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 257,
    transform: "translate(671.722 415.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 27,
    transform: "translate(713.722 365.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 27,
    transform: "translate(713.722 685.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.339,0A32.339,32.339,0,1,1,0,32.339,32.339,32.339,0,0,1,32.339,0Z",
    transform: "translate(809.756 821.132)",
    fill: "#A47CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.169,0h210.2a16.169,16.169,0,1,1,0,32.339H16.169A16.169,16.169,0,0,1,16.169,0Z",
    transform: "translate(720.825 245.101)",
    fill: "#e6e6e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationScanQrCode);
export default __webpack_public_path__ + "static/media/illustration_scan_qr_code.62137164eee5790225f1cc62e5c906c3.svg";
export { ForwardRef as ReactComponent };